import { render } from "./tabla.vue?vue&type=template&id=a58ebd42"
import script from "./tabla.vue?vue&type=script&lang=js"
export * from "./tabla.vue?vue&type=script&lang=js"

import "./tabla.vue?vue&type=style&index=0&id=a58ebd42&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__